import React from 'react';
import { AwardIngestionView } from './AwardIngestionView';

export interface AwardIngestionRouteProps {
  className?: string;
}

const AwardIngestionRoute: React.FC<AwardIngestionRouteProps> = ({ className = '' }) => (
  <div className={className}>
    <AwardIngestionView />
  </div>
);

export default AwardIngestionRoute;
